import { type ReactNode } from "react";
import classNames from "classnames";

interface Props<T extends any> {
  className?: string;
  data: T;
  children: (data: T, indexLine?: number) => ReactNode;
  isOpen?: boolean;
  indexLine?: number;
}

const LineItemDetails = <T extends any>({ className, data, isOpen, indexLine, children }: Props<T>) => (
  <div className={classNames(className, "scha__detalied-line-extender__holder", isOpen && "__open")}>
    <div className={"scha__detalied-line-extender__body" + (isOpen ? "__open" : "")}>{children(data, indexLine)}</div>
  </div>
);

export default LineItemDetails;
